import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { SavedReplyValidation } from 'uplisting-frontend/validations';

export default class SavedReplyRepositoryService extends BaseRepositoryService<
  ModelRegistry['saved-reply']
> {
  recordName = 'saved-reply';
  implementMethods = [
    'findAll',
    'findRecord',
    'buildChangeset',
    'createRecord',
  ];

  validation = SavedReplyValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/saved-reply': SavedReplyRepositoryService;
  }
}
